module.exports = __webpack_public_path__ + "static/img/1_1_1.2d1e08f3.jpg";